import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GetTokenBindingModel } from 'src/app/api/models/base.model';
import { Customer, IsValidMigrationKeyBindingModel, ItemCode, SendMigrationLinkBindingModel } from 'src/app/api/models/web-booking.models';
import { AppConstants } from 'src/app/app.constants';
import { BaseComponent } from 'src/app/layout/main/base.component';
import { Gender } from 'src/app/misc/enums';

@Component({
  selector: 'app-migrate-customer',
  templateUrl: './migrate-customer.component.html',
  styleUrls: ['./migrate-customer.component.scss']
})
export class MigrateCustomerComponent extends BaseComponent implements OnInit {

  form: FormGroup;
  isValidCode: boolean;

  email: string;
  customerId: string;

  healthFunds: any[];
  states: any[];
  selectedState: any = { suburbs: [] };
  filteredSuburbs: any[] = [];
  countries: any[];
  genders: any[];
  yesNo = [];
  
  public modalRef: BsModalRef;
  @ViewChild('addressNotesDialog') addressNotesDialog: TemplateRef<any>;

  isAddressHasBeenClicked = false;

  ngOnInit() {
    this.app.pageTitle = 'Update your information';

    this.genders = [
      { value: 1, viewValue: 'Male' },
      { value: 2, viewValue: 'Female' }
    ];

    this.yesNo = [
      { value: true, viewValue: 'Yes' },
      { value: false, viewValue: 'No' }
    ];

    // this.form = this.app.formBuilder.group({
    //   email: ['', { validators: Validators.required }],
    //   firstName: ['', { validators: Validators.required }],
    //   lastName: ['', { validators: Validators.required }],
    //   mobilePhoneNumber: ['', { validators: Validators.required }],
    //   dateOfBirth: [''],
    //   migrationKey: ['', { validators: Validators.required }],
    //   customerId: [''],
    //   password: ['', { validators: Validators.required }],
    //   confirmPassword: ['', { validators: Validators.required }],
    //   healthFundId: [''],
    //   gender: [''],
    //   isAustralianPhoneNumber: [''],
    //   address1: [''],
    //   address4: [''],
    //   postCode: [''],
    //   stateId: [''],
    //   countryId: ['']
    // });
    
    this.form = this.app.formBuilder.group({
      email: [''],
      firstName: [''],
      lastName: [''],
      mobilePhoneNumber: ['', { validators: Validators.required }],
      dateOfBirth: [''],
      migrationKey: ['', { validators: Validators.required }],
      customerId: [''],
      password: ['', { validators: Validators.required }],
      confirmPassword: ['', { validators: Validators.required }],
      healthFundId: [''],
      gender: [''],
      gender1: [''],
      isAustralianPhoneNumber: [''],
      address1: [''],
      address4: [''],
      postCode: [''],
      stateId: [''],
      countryId: ['']
    });
    
    this.baseTriggerChild.subscribe(event => {
      this.app.spinner.hide();

      this.customerId = this.app.storageService.getItem(AppConstants.CustomerId);
      if (this.app.stringService.isEmpty(this.customerId)) {
        this.app.router.navigate([AppConstants.RouteInvalid]);
        return;
      }

      this.email = this.app.storageService.getItem(AppConstants.CustomerEmail);
      if (this.app.stringService.isEmpty(this.email)) {
        this.app.router.navigate([AppConstants.RouteInvalid]);
        return;
      }

      this.getHealthFunds();

      this.scrollTo();

    });
    this.start();
  }

  getHealthFunds(): void {
    this.app.spinner.show();
    const model = { branchId: this.app.branch.branchId };
    this.app.webBookingService.GetHealthFunds(model).subscribe(
      data => {
        this.healthFunds = data;
        this.getStates();
      },
      error => {
        this.app.spinner.hide();
        this.showErrorMessage(error);
      }
    );
  }

  getStates(): void {
    this.app.webBookingService.GetStates().subscribe(
      data => {
        this.states = data;
        this.getCountries();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  getCountries(): void {
    this.app.webBookingService.GetCountries().subscribe(
      data => {
        this.countries = data;
        this.app.spinner.hide();
      },
      error => {
        this.showErrorMessage(error);
        this.app.spinner.hide();
      }
    );
  }

  resend() {
    this.app.spinner.show();
    const m = new SendMigrationLinkBindingModel();
    m.email = this.email;
    m.branchId = this.app.branch.branchId;
    this.app.webBookingService.SendMigrationLink(m)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.storageService.setItem(AppConstants.CustomerId, data.customerId);
          this.app.storageService.setItem(AppConstants.CustomerEmail, this.email);
          this.showInfoMessage('Please check your email to active your online account');
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  validateMigrationKey() {
    this.app.spinner.show();
    const m = new IsValidMigrationKeyBindingModel();
    m.migrationKey = this.form.value.migrationKey;
    m.customerId = this.customerId;
    this.app.webBookingService.IsValidMigrationKey(m)
      .subscribe(
        data => {
          if (data.valid) {
            this.app.spinner.hide();

            if (data.address != null && data.address.state != null) {
              for (let a = 0; a < this.states.length; a++) {
                if (data.address.state.stateId == this.states[a].stateId) {
                  this.selectedState = this.states[a];
                }
              }
            }

            let selectedSuburb = '';
            if (this.selectedState != null && this.selectedState.suburbs != null && this.selectedState.suburbs.length > 0) {
              for (let a = 0; a < this.selectedState.suburbs.length; a++) {
                if (this.app.stringService.isNotEmpty(data.address.address4) && data.address.address4.toUpperCase() == this.selectedState.suburbs[a].name.toUpperCase()) {
                  selectedSuburb = this.selectedState.suburbs[a].name;
                }
              }
            }

            const model =
            {
              firstName: data.firstName,
              lastName: data.lastName,
              email: this.email,
              mobilePhoneNumber: data.mobilePhoneNumber,
              dateOfBirth: this.setBirthOfDate(data.dateOfBirth),
              password: '',
              confirmPassword: '',
              migrationKey: this.form.value.migrationKey,
              customerId: this.customerId,
              healthFundId: data.healthFundId,
              gender: data.gender,
              gender1: '',
              isAustralianPhoneNumber: false,
              address1: data.address != null ? data.address.address1 : '',
              address4: selectedSuburb,
              postCode: data.address != null ? data.address.postCode : '',
              stateId: data.address != null && data.address.state != null ? data.address.state.stateId : '',
              countryId: data.address != null && data.address.country ? data.address.country.countryId : '',
            };

            console.log(model);
            this.form.setValue(model);

            this.isValidCode = true;
          }
          else {
            this.app.spinner.hide();
            this.showErrorMessage('Failed to validate account activation code');
            this.isValidCode = false;
          }
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage('Failed to validate account activation code');
          this.isValidCode = false;
        });
  }

  showAddressNotification()
  {    
    if (this.isAddressHasBeenClicked) return;    
    this.isAddressHasBeenClicked = true;
    this.modalRef = this.app.modalService.show(
      this.addressNotesDialog,
      {
        class: 'modal-dialog-centered modal-dialog-scrollable',
        ignoreBackdropClick: true,
        keyboard: false
      }
    );
  }

  onAddress1Change(e:any)
  {
    setTimeout(() => { 
      const model = this.form.getRawValue();
      if (this.app.stringService.isNotValidAddress1(model.address1)) {
        model.address1 = '';
        this.form.patchValue(model);
        this.showErrorMessage('PO Box is not allowed.');
        this.app.spinner.hide();
        return false;
      }
    }, 100);
  }

  closeDialog(): void {
    this.modalRef.hide();
  }

  get formGroup() { return this.form.controls; }

  setBirthOfDate(dateOfBirth: string): Date {
    if (this.app.stringService.isNotEmpty(dateOfBirth)) { return this.app.dateService.getNewDate(dateOfBirth); }
    return new Date();
  }

  submit() {
    if (this.isValidCode) {
      this.migrate();
    }
    else {
      this.validateMigrationKey();
    }
  }

  migrate() {
    // if (this.app.stringService.isEmpty(this.form.value.firstName)) {
    //   this.showErrorMessage('First Name is required.');
    //   return;
    // }
    // if (this.app.stringService.isEmpty(this.form.value.lastName)) {
    //   this.showErrorMessage('Last Name is required.');
    //   return;
    // }
    // if (this.app.stringService.isNotEmpty(this.form.value.dateOfBirth)) {
    //   const date = new Date(this.form.value.dateOfBirth);
    //   this.form.value.dateOfBirth = this.app.dateService.formatDateTime(date);
    // }
    if (this.app.stringService.isEmpty(this.form.value.mobilePhoneNumber)) {
      this.showErrorMessage('Mobile No. is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.address1)) {
      this.showErrorMessage('Address 1 is required.');
      return;
    }
    if (this.app.stringService.isNotValidAddress1(this.form.value.address1)) {
      this.showErrorMessage('PO Box is not allowed.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.address4)) {
      this.showErrorMessage('Suburb is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.postCode)) {
      this.showErrorMessage('Postcode is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.stateId)) {
      this.showErrorMessage('State is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.countryId)) {
      this.showErrorMessage('Country is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.password)) {
      this.showErrorMessage('Password is required.');
      return;
    }
    if (this.app.stringService.isEmpty(this.form.value.confirmPassword)) {
      this.showErrorMessage('Confirm Password is required.');
      return;
    }
    if (this.form.value.confirmPassword != this.form.value.password) {
      this.showErrorMessage('Password and Confirm Password did not match.');
      return;
    }

    this.app.spinner.show();
    this.app.webBookingService.MigrateCustomer(this.form.value)
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.showSuccessMessage('Your account successfully activated online.');
          this.getToken(this.email, this.form.value.password);
          this.app.storageService.removeItem(AppConstants.CustomerEmail);
          this.app.storageService.removeItem(AppConstants.CustomerId);
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getToken(email: string, password: string) {
    const model: GetTokenBindingModel =
    {
      username: email,
      email,
      password,
      grand_type: 'password'
    };
    this.app.spinner.show();
    this.app.webBookingService.GetToken(model)
      .subscribe(
        data => {
          this.app.spinner.hide();
          data.created_date = this.app.dateService.formatDateTime(new Date());
          this.app.storageService.setItem(AppConstants.Token, JSON.stringify(data));
          this.getProfile();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  getProfile(): void {
    this.app.webBookingService.GetProfile()
      .subscribe(
        data => {
          this.app.spinner.hide();
          this.app.customer = data;
          this.app.storageService.setItem(AppConstants.Customer, JSON.stringify(this.app.customer));
          this.checkCustomerData();
          this.redirectToNextPage();
        },
        error => {
          this.app.spinner.hide();
          this.showErrorMessage(error);
        });
  }

  backToLogin(): void {
    this.app.router.navigate([AppConstants.RouteLogin]);
  }

  formControlErrorMessage(formControl: string, maxlength: number = 11, minlength: number = 6): string {
    if (this.form.controls[formControl].touched) {
      return this.form.controls[formControl].hasError('required') ? 'This is field is required.' :
        this.form.controls[formControl].hasError('email') ? 'Must be a valid email.' :
          this.form.controls[formControl].hasError('minlength') ? 'Minimum length is ' + minlength + '.' :
            this.form.controls[formControl].hasError('maxlength') ? 'Maximum length is ' + maxlength + '.' :
              '';
    }
  }

  onStateOptionClicked(item) {
    this.selectedState = item;

    const data = this.form.getRawValue();
    data.postCode = '';
    data.address4 = '';
    this.form.patchValue(data);
  }

  onSuburbOptionClicked(item) {
    const data = this.form.getRawValue();
    data.postCode = item.postcode;
    this.form.patchValue(data);
  }

  filterSuburb(value: string): void {
    const filterValue = value.toLowerCase();

    if (this.selectedState.suburbs.length > 0) {
      this.filteredSuburbs = this.selectedState.suburbs.filter(suburb => {
        return suburb.name.toLowerCase().indexOf(filterValue) === 0;
      });
    } else {
      this.filteredSuburbs = [];
    }
  }
}
